export default {
    product_pricing: {
        get_1_month_extra_for_free: 'ទទួលបាន 1 ខែបន្ថែមដោយឥតគិតថ្លៃ',
        get_2_months_extra_for_free: 'ទទួលបាន 2 ខែបន្ថែមដោយឥតគិតថ្លៃ',
    },
    product_descriptions: {
        get_started_with_your_own_virtual_server:
            'ចាប់ផ្តើមជាមួយម៉ាស៊ីនមេនិម្មិតផ្ទាល់ខ្លួនរបស់អ្នក',
        more_resources_for_your_work: 'ធនធានច្រើនទៀតសម្រាប់ការងាររបស់អ្នក',
        a_natural_fit_for_small_and_medium_businesses:
            'សមធម្មជាតិសម្រាប់អាជីវកម្មខ្នាតតូច និងមធ្យម',
        designed_specifically_for_high_class_enterprises:
            'រចនាឡើងជាពិសេសសម្រាប់សហគ្រាសលំដាប់ខ្ពស់។',
    },
};
